$(function ($) {
  /*---------------- Search Popup ------------------*/
  $(".search-toggle").on('click', function(e) {
    $(".header-section").toggleClass('search-active');
    e.preventDefault();
  });
  // close when click off of container
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.search-toggle, .search-toggle *, .header-section, .header-section *')) {
      $('.search-toggle, .header-section').removeClass('search-active');
    }
  });
  /*---------------- Magnific Youtube ------------------*/
  $('.magnific-youtube').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  /*---------------- Responsive Footer Menu ------------------*/
  $('.f-title').on("click", function(e) {
    if ($(this).hasClass('menushow')) {
      remove_styles();
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    } else {
      remove_styles();
      $(this).addClass('menushow');
      $(this).next('ul').addClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').addClass('menushowtoggle');
      }
    }
    e.stopPropagation();
    e.preventDefault();
  });
  function remove_styles() {
    $('.f-title').each(function() {
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    });
  }
  /*---------------- Responsive Menu ------------------*/
  $(".m-menu-btn").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".header-section").toggleClass("menu-open");
    $(this).toggleClass("m-menu-btn-ext");
    e.preventDefault();
  });
  $(".menu-close-btn").click(function() {
    $(".header-section").removeClass("menu-open");
    $(".m-menu-btn").removeClass("m-menu-btn-ext");
  });
  $('nav.menu').on("click", ".has-submenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });
  $('nav.menu').on("click", ".has-multisubmenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.m-menu-btn, .m-menu-btn , .header-section, .header-section *')) {
      $('.m-menu-btn, .header-section').removeClass('menu-open');
      if ($(".m-menu-btn").hasClass("m-menu-btn-ext")) {
        $(".m-menu-btn").removeClass("m-menu-btn-ext");
      }
    }
  });
});


/*---------------- contant height equal  ------------------*/
/*
$(window).load(function() {
  equalheight('.ingredients-block');
  equalheight('.ingredients-block > figure > img');
  //equalheight('.powerfull_row .same');
});
$(window).resize(function() {
  equalheight('.ingredients-block');
  equalheight('.ingredients-block > figure > img');
  //equalheight('.powerfull_row .same');
});

$(window).load(function() {
  equalheight('.natural-clinical img');
  //equalheight('.powerfull_row .same');
});
$(window).resize(function() {
  equalheight('.natural-clinical img');
  //equalheight('.powerfull_row .same');
});

$(window).load(function() {
  equalheight('.natural-clinical p');
  //equalheight('.powerfull_row .same');
});
$(window).resize(function() {
  equalheight('.natural-clinical p');
  //equalheight('.powerfull_row .same');
});
*/
/*----------------FAQ accordion------------------*/
$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.article-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();
    $next.slideToggle();
    $this.parent().toggleClass('open');
    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);
});

/* Product detail shipping */ 
$('.select-shipping ul li label').click(function(){
  $('li label').removeClass("active");
  $(this).addClass("active");
});
/* Product detail shipping End*/


$(function ($) {
  $('body').on('change', '.prdpgOpt', function(e) {
    if($(this).attr('id') == 'test1') {
      $(".main-prd-data-var").val($('#threebox').val());
    }
    else if ($(this).attr('id') == 'onetime3') {
      $(".main-prd-data-var").val($('#threebox').val());
    }
    else {
      $(".main-prd-data-var").val($('#normalbox').val());
    }
  });
  $('body').on('click','.natural-adv-joint-wrap',function(e) {
    e.preventDefault();
    if($('#threebox').val() == $(".main-prd-data-var").val()) {
      $('#AddToCartForm2').submit();
    }
    else {
      $(this).closest('form').submit();
    }
  });
  $(document).ready(function() {
    //$('.natural-joint-main-wrap .prdpgOpt:eq(0)').trigger('change');
  });
  $('body').on('change', '.chg-subscribe-opt', function(e) {
    $(".bold-ro__subscribe-radio-btn").click();
    if($(this).attr('id') == 'test4') {
      $('.freq-msg-wrap').hide();
      $('.on-fly-get-optns').hide();
      $(".bold-ro__one-time-radio-btn").click();
    }
    else {
      $('.freq-msg-wrap').show();
      $('.on-fly-get-optns').show();
      $(".bold-ro__subscribe-radio-btn").click();
      var get_opt_data = $('.bold-ro__frequency-num').find('option').length;
      var get_opt_html = '';
      if(get_opt_data > 0) {
        var get_freq_nm = '';
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Month') !== -1) {
          get_freq_nm = 'months';
        }
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Week') !== -1) {
          get_freq_nm = 'weeks';
        }
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Year') !== -1) {
          get_freq_nm = 'years';
        }
        $('.bold-ro__frequency-num option').each(function(a,b) {
          if(a<get_opt_data/2) {
            var activeClass = '';
            if(a == 0) {
              activeClass = 'activeLabel';
            }
            get_opt_html += '<label class="'+activeClass+'">'+$(this).val()+' '+get_freq_nm+'<input name="nat_bold_freq" type="radio" class="customDataRadio" value="'+$(this).val()+'"></label>'
          }
        });
      }
      $('.on-fly-get-optns').html('');
      $('.on-fly-get-optns').html(get_opt_html);
    }
  });

  $('body').on('change', '.customDataRadio', function(e) {
    var get_opt_data = $('.on-fly-get-optns').find('label').length;
    if(get_opt_data > 0) {
      $('.on-fly-get-optns label').each(function(a,b) {
        $(this).removeClass('activeLabel');
      });
    }
    $(this).parent().addClass('activeLabel');
    var get_cur_val = $(this).val();
    $('.bold-ro__frequency-num').val(get_cur_val);
  });
  
  
  
  $('body').on('click', '.button.minus', function(e) {
    e.preventDefault();
    var get_qty = $(this).closest('.cart-quantity-wrapper').find('input').val();
    if(get_qty >= 1) {
      $(this).closest('.cart-quantity-wrapper').find('input').val(get_qty - 1);
      $(this).closest('.cart-quantity-wrapper').find('input').trigger('change');
    }
  });
  $('body').on('click', '.button.plus', function(e) {
    e.preventDefault();
    var get_qty = $(this).closest('.cart-quantity-wrapper').find('input').val();
    $(this).closest('.cart-quantity-wrapper').find('input').val(parseInt(get_qty) + 1);
    $(this).closest('.cart-quantity-wrapper').find('input').trigger('change');
  });
  /*********************************************/
  var header = document.getElementById("stickey-header");
  var sticky = header.offsetTop;
  function myFunction() {
    if (window.pageYOffset > sticky) {
      header.classList.add("fixed-header");
    } else {
      header.classList.remove("fixed-header");
    }
  }
  window.onscroll = function() {myFunction()};
  /*********************************************/
  /*
  $(window).load(function() {
    //equalheight('.template-index .natural-info-inner p');
    //calc_height();
  });
  $(window).resize(function() {
    //equalheight('.template-index .natural-info-inner p');
    //calc_height();
    var highestBox = 0;
    // Select and loop the elements you want to equalise
    $('.template-index .natural-info-inner p', this).each(function(){
      // If this box is higher than the cached highest then store it
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }
    });  
    $('.template-index .natural-info-inner p',this).height(highestBox);
  });
  $(document).ready(function(){
    var highestBox = 0;
    // Select and loop the elements you want to equalise
    $('.template-index .natural-info-inner p', this).each(function(){
      // If this box is higher than the cached highest then store it
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }
    });  
    $('.template-index .natural-info-inner p',this).height(highestBox);
  });
  */
  
  //add simple support for background images:
  document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });
  
});